import React, { useEffect, useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import toastr from "toastr";
import apiServiceHandler from "../../service/apiService";

const IgniteModal = ({ isOpen, onClose }) => {
  const [ignition, setIgnition] = useState("");

  const textAreaRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
        const textArea = textAreaRef.current;
        if (textArea) {
          textArea.focus();
          const length = textArea.value.length;
          textArea.setSelectionRange(length, length);
        }
      }
  }, [isOpen]);

  const saveIgnition = async (e) => {
    e.preventDefault();

    if (!ignition) {
      toastr.error("Please fill the Ignition");
      return;
    }

    const payload = {
      statement: ignition,
      progress: 100,
    };

    try {
      const res = await apiServiceHandler("POST", "api/ignition", payload);
      if (res.status) {
        toastr.success(res.message);
        onClose();
        setIgnition("");
      }
    } catch (error) {
      console.log("Failed to save credo" + error);
    }
  };

  useEffect(() => {
    const fetchIgnition = async () => {
      try {
        const res = await apiServiceHandler("GET", "api/ignition", {});
        if (res.status) {
          setIgnition(res.data.statement);
        }
      } catch (error) {
        console.log("Failed to fetch data");
      }
    };
    fetchIgnition();
  }, [isOpen]);

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      centered
      className="next90-modal"
    >
      <Modal.Header
        closeButton
        style={{
          borderBottom: "none",
          backgroundColor: "#26262f",
          color: "#d1b794",
        }}
      >
        <Modal.Title style={{ fontWeight: "400" }}>IGNITION</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ backgroundColor: "#26262f" }}>
        <div
          className="edit-key"
          style={{ display: "flex", flexDirection: "column" }}
        >
          <textarea
            type="text"
            className="credo-input"
            ref={textAreaRef}
            value={ignition}
            onChange={(e) => setIgnition(e.target.value)}
          />
        </div>
      </Modal.Body>
      <Modal.Footer
        style={{
          borderTop: "none",
          paddingTop: "1rem",
          backgroundColor: "#26262f",
        }}
      >
        <div
          style={{
            display: "flex",
            gap: "1rem",
            alignItems: "center",
          }}
        >
          <button
            type="button"
            className="save-next90-btn"
            onClick={saveIgnition}
          >
            <span className="driver-button__label">SAVE</span>
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default IgniteModal;
